import { render, staticRenderFns } from "./vipranking.vue?vue&type=template&id=8bf197e2&scoped=true"
import script from "./vipranking.vue?vue&type=script&lang=js"
export * from "./vipranking.vue?vue&type=script&lang=js"
import style0 from "./vipranking.vue?vue&type=style&index=0&id=8bf197e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf197e2",
  null
  
)

export default component.exports